import { createContext } from 'react';

export default createContext({
  openModal: () => null,
  closeModal: () => null,
  destroyModal: () => null
});
